"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "search-container" };
const _hoisted_2 = ["placeholder"];
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { key: 1 };
const _hoisted_9 = { key: 2 };
const _hoisted_10 = { key: 0 };
const _hoisted_11 = { key: 1 };
const _hoisted_12 = { key: 0 };
const _hoisted_13 = { key: 1 };
const _hoisted_14 = { key: 0 };
const _hoisted_15 = { key: 1 };
const _hoisted_16 = { id: "selections" };
const _hoisted_17 = { class: "selection-row" };
const _hoisted_18 = ["name", "id", "onUpdate:modelValue"];
const _hoisted_19 = ["for"];
const _hoisted_20 = { class: "selection-row" };
const _hoisted_21 = ["name", "id", "onUpdate:modelValue"];
const _hoisted_22 = ["for"];
const _hoisted_23 = { key: 0 };
const _hoisted_24 = { key: 1 };
const _hoisted_25 = { key: 2 };
const _hoisted_26 = { class: "selection-row" };
const _hoisted_27 = ["name", "id"];
const _hoisted_28 = ["name", "id", "onUpdate:modelValue"];
const _hoisted_29 = ["for"];
const _hoisted_30 = { class: "selection-row" };
const _hoisted_31 = ["name", "id", "onUpdate:modelValue"];
const _hoisted_32 = ["for"];
const _hoisted_33 = {
    key: 1,
    class: "expansion-icon card-tag tag-none"
};
const _hoisted_34 = { class: "card-list-cards-list" };
const _hoisted_35 = { class: "card-list-cards-list" };
const _hoisted_36 = { class: "card-list-cards-list" };
const _hoisted_37 = { class: "card-list-cards-list" };
const _hoisted_38 = { class: "card-list-cards-list" };
const _hoisted_39 = { class: "card-list-cards-list" };
const _hoisted_40 = { class: "player_home_colony_cont" };
const _hoisted_41 = { class: "player_home_colony_cont" };
const _hoisted_42 = { class: "milestones" };
const _hoisted_43 = { class: "player_home_colony_cont" };
const _hoisted_44 = { class: "awards" };
const _hoisted_45 = { class: "player_home_colony_cont" };
const _hoisted_46 = { class: "turmoil_agenda_cont" };
const _hoisted_47 = { style: { "padding": "12px", "background-image": "linear-gradient(rgb(156, 96, 45), black)", "border-radius": "8px", "height": "120px" } };
const _hoisted_48 = { style: { "text-align": "center" } };
const _hoisted_49 = { class: "free-floating-preferences-icon" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Card = (0, vue_1.resolveComponent)("Card");
    const _component_global_event = (0, vue_1.resolveComponent)("global-event");
    const _component_colony = (0, vue_1.resolveComponent)("colony");
    const _component_milestone = (0, vue_1.resolveComponent)("milestone");
    const _component_award = (0, vue_1.resolveComponent)("award");
    const _component_turmoil_agenda = (0, vue_1.resolveComponent)("turmoil-agenda");
    const _component_preferences_icon = (0, vue_1.resolveComponent)("preferences-icon");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)(["card-list-container", _ctx.getLanguageCssClass()])
    }, [
        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h1", null, [...(_cache[32] || (_cache[32] = [
                (0, vue_1.createTextVNode)("Cards List", -1)
            ]))])), [
            [_directive_i18n]
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_1, [
            (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                ref: "filter",
                class: "filter",
                placeholder: _ctx.$t('filter'),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.filterText) = $event))
            }, null, 8, _hoisted_2), [
                [vue_1.vModelText, _ctx.filterText]
            ]),
            (0, vue_1.createElementVNode)("button", {
                id: "namesOnlyToggle",
                name: "namesOnly",
                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.toggleNamesOnly()))
            }, [
                (_ctx.namesOnly === true)
                    ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_3, [...(_cache[33] || (_cache[33] = [
                            (0, vue_1.createTextVNode)("Names only", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                    : (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_4, [...(_cache[34] || (_cache[34] = [
                            (0, vue_1.createTextVNode)("Full text", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
            ]),
            (0, vue_1.createElementVNode)("button", {
                id: "sort-order",
                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.toggleSortOrder())),
                style: { "width": "85px" }
            }, [
                (_ctx.sortOrder === 'a')
                    ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_5, [...(_cache[35] || (_cache[35] = [
                            (0, vue_1.createTextVNode)("A-Z", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                    : (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_6, [...(_cache[36] || (_cache[36] = [
                            (0, vue_1.createTextVNode)("0-9", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                _cache[37] || (_cache[37] = (0, vue_1.createTextVNode)(" ↕ ", -1))
            ]),
            (0, vue_1.createElementVNode)("button", {
                id: "show-vps-only",
                onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.toggleVps())),
                style: { "width": "63px" }
            }, [
                (_ctx.vps === 0)
                    ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_7, [...(_cache[38] || (_cache[38] = [
                            (0, vue_1.createTextVNode)("all", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.vps === 1)
                    ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_8, [...(_cache[39] || (_cache[39] = [
                            (0, vue_1.createTextVNode)("+VPs", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.vps === 2)
                    ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_9, [...(_cache[40] || (_cache[40] = [
                            (0, vue_1.createTextVNode)("-VPs", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                    : (0, vue_1.createCommentVNode)("", true)
            ]),
            (0, vue_1.createElementVNode)("button", {
                id: "show-metadata",
                onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.toggleShowMetadata())),
                style: { "width": "60px" },
                title: "Show/hide colony metadata"
            }, [
                (_ctx.showMetadata === true)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_10, "🛰️■"))
                    : ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_11, "🛰️□"))
            ]),
            (0, vue_1.createElementVNode)("button", {
                id: "tall-cards",
                onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.toggleTallCards())),
                style: { "width": "90px" },
                title: "Show tall / short cards"
            }, [
                (_ctx.tallCards === true)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_12, [...(_cache[41] || (_cache[41] = [
                            (0, vue_1.createTextVNode)("🂠→", -1),
                            (0, vue_1.createElementVNode)("span", { class: "small-card" }, "🂠", -1)
                        ]))]))
                    : ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_13, [...(_cache[42] || (_cache[42] = [
                            (0, vue_1.createElementVNode)("span", { class: "small-card" }, "🂠", -1),
                            (0, vue_1.createTextVNode)("→🂠", -1)
                        ]))]))
            ]),
            (0, vue_1.createElementVNode)("button", {
                id: "advanced-search-collapser",
                onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.toggleAdvancedSearch()))
            }, [
                (_ctx.showAdvanced === true)
                    ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_14, [...(_cache[43] || (_cache[43] = [
                            (0, vue_1.createTextVNode)("Advanced «", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                    : (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_15, [...(_cache[44] || (_cache[44] = [
                            (0, vue_1.createTextVNode)("Advanced »", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
            ])
        ]),
        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("div", _hoisted_16, [
            (0, vue_1.createElementVNode)("div", _hoisted_17, [
                (0, vue_1.createElementVNode)("button", {
                    id: "toggle-checkbox",
                    onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.invertExpansions()))
                }, "-"),
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.allModules, (expansion) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", { key: expansion }, [
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            name: expansion,
                            id: `${expansion}-checkbox`,
                            "onUpdate:modelValue": ($event) => ((_ctx.expansions[expansion]) = $event)
                        }, null, 8, _hoisted_18), [
                            [vue_1.vModelCheckbox, _ctx.expansions[expansion]]
                        ]),
                        (0, vue_1.createElementVNode)("label", {
                            for: `${expansion}-checkbox`,
                            class: "expansion-button"
                        }, [
                            (0, vue_1.createElementVNode)("div", {
                                class: (0, vue_1.normalizeClass)(["expansion-icon", _ctx.expansionIconClass(expansion)])
                            }, null, 2)
                        ], 8, _hoisted_19)
                    ]));
                }), 128))
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_20, [
                (0, vue_1.createElementVNode)("button", {
                    id: "toggle-checkbox",
                    onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.invertTypes()))
                }, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[45] || (_cache[45] = [
                            (0, vue_1.createTextVNode)("-", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                ]),
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.allTypes, (type) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", { key: type }, [
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            name: `${type}-cardType`,
                            id: `${type}-cardType-checkbox`,
                            "onUpdate:modelValue": ($event) => ((_ctx.types[type]) = $event)
                        }, null, 8, _hoisted_21), [
                            [vue_1.vModelCheckbox, _ctx.types[type]]
                        ]),
                        (0, vue_1.createElementVNode)("label", {
                            for: `${type}-cardType-checkbox`,
                            class: "expansion-button"
                        }, [
                            (type === 'colonyTiles')
                                ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_23, [...(_cache[46] || (_cache[46] = [
                                        (0, vue_1.createTextVNode)("Colony Tiles", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ])
                                : (type === 'globalEvents')
                                    ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_24, [...(_cache[47] || (_cache[47] = [
                                            (0, vue_1.createTextVNode)("Global Events", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ])
                                    : (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_25, [
                                        (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(type), 1)
                                    ])), [
                                        [_directive_i18n]
                                    ])
                        ], 8, _hoisted_22)
                    ]));
                }), 128))
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_26, [
                (0, vue_1.createElementVNode)("button", {
                    id: "toggle-checkbox",
                    onClick: _cache[9] || (_cache[9] = ($event) => (_ctx.invertTags()))
                }, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[48] || (_cache[48] = [
                            (0, vue_1.createTextVNode)("-", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                ]),
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.allTags, (tag) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", { key: tag }, [
                        (tag === 'event')
                            ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("input", {
                                key: 0,
                                type: "checkbox",
                                name: `${tag}-cardType`,
                                id: `${tag}-tag-checkbox`,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.types.event) = $event))
                            }, null, 8, _hoisted_27)), [
                                [vue_1.vModelCheckbox, _ctx.types.event]
                            ])
                            : (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("input", {
                                key: 1,
                                type: "checkbox",
                                name: `${tag}-cardType`,
                                id: `${tag}-tag-checkbox`,
                                "onUpdate:modelValue": ($event) => ((_ctx.tags[tag]) = $event)
                            }, null, 8, _hoisted_28)), [
                                [vue_1.vModelCheckbox, _ctx.tags[tag]]
                            ]),
                        (0, vue_1.createElementVNode)("label", {
                            for: `${tag}-tag-checkbox`,
                            class: "expansion-button"
                        }, [
                            (0, vue_1.createElementVNode)("div", {
                                class: (0, vue_1.normalizeClass)(`expansion-icon card-tag tag-${tag}`)
                            }, null, 2)
                        ], 8, _hoisted_29)
                    ]));
                }), 128))
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_30, [
                (0, vue_1.createElementVNode)("button", {
                    id: "toggle-checkbox",
                    onClick: _cache[11] || (_cache[11] = ($event) => (_ctx.invertResources()))
                }, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[49] || (_cache[49] = [
                            (0, vue_1.createTextVNode)("-", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                ]),
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.allResources, (resource) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", { key: resource }, [
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            name: `${resource}-cardType`,
                            id: `${resource}-resource-checkbox`,
                            "onUpdate:modelValue": ($event) => ((_ctx.resources[resource]) = $event)
                        }, null, 8, _hoisted_31), [
                            [vue_1.vModelCheckbox, _ctx.resources[resource]]
                        ]),
                        (0, vue_1.createElementVNode)("label", {
                            for: `${resource}-resource-checkbox`,
                            class: "expansion-button"
                        }, [
                            (resource !== 'none')
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                    key: 0,
                                    class: (0, vue_1.normalizeClass)(["expansion-icon card-resource", _ctx.cardResourceCSS[resource]])
                                }, null, 2))
                                : ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_33))
                        ], 8, _hoisted_32)
                    ]));
                }), 128))
            ])
        ], 512), [
            [vue_1.vShow, _ctx.showAdvanced]
        ]),
        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("section", _hoisted_34, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h2", null, [...(_cache[50] || (_cache[50] = [
                    (0, vue_1.createTextVNode)("Project Cards", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.visibleProjectCards, (card, __, ___, _cached) => {
                const _memo = ([card, _ctx.tallCards]);
                if (_cached && _cached.key === card && (0, vue_1.isMemoSame)(_cached, _memo))
                    return _cached;
                const _item = ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                    class: "cardbox",
                    key: card
                }, [
                    (0, vue_1.createVNode)(_component_Card, {
                        card: { 'name': card },
                        autoTall: _ctx.tallCards
                    }, null, 8, ["card", "autoTall"])
                ]));
                _item.memo = _memo;
                return _item;
            }, _cache, 12), 128)),
            _cache[51] || (_cache[51] = (0, vue_1.createElementVNode)("br", null, null, -1))
        ], 512), [
            [vue_1.vShow, _ctx.visibleProjectCards.length > 0]
        ]),
        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("section", _hoisted_35, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h2", null, [...(_cache[52] || (_cache[52] = [
                    (0, vue_1.createTextVNode)("Corporations", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.visibleCorporationCards, (card, __, ___, _cached) => {
                const _memo = ([card, _ctx.tallCards]);
                if (_cached && _cached.key === card && (0, vue_1.isMemoSame)(_cached, _memo))
                    return _cached;
                const _item = ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                    class: "cardbox",
                    key: card
                }, [
                    (0, vue_1.createVNode)(_component_Card, {
                        card: { 'name': card },
                        autoTall: _ctx.tallCards
                    }, null, 8, ["card", "autoTall"])
                ]));
                _item.memo = _memo;
                return _item;
            }, _cache, 14), 128)),
            _cache[53] || (_cache[53] = (0, vue_1.createElementVNode)("br", null, null, -1))
        ], 512), [
            [vue_1.vShow, _ctx.visibleCorporationCards.length > 0]
        ]),
        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("section", _hoisted_36, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h2", null, [...(_cache[54] || (_cache[54] = [
                    (0, vue_1.createTextVNode)("Preludes", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.visiblePreludeCards, (card, __, ___, _cached) => {
                const _memo = ([card, _ctx.tallCards]);
                if (_cached && _cached.key === card && (0, vue_1.isMemoSame)(_cached, _memo))
                    return _cached;
                const _item = ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                    class: "cardbox",
                    key: card
                }, [
                    (0, vue_1.createVNode)(_component_Card, {
                        card: { 'name': card },
                        autoTall: _ctx.tallCards
                    }, null, 8, ["card", "autoTall"])
                ]));
                _item.memo = _memo;
                return _item;
            }, _cache, 16), 128)),
            _cache[55] || (_cache[55] = (0, vue_1.createElementVNode)("br", null, null, -1))
        ], 512), [
            [vue_1.vShow, _ctx.visiblePreludeCards.length > 0]
        ]),
        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("section", _hoisted_37, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h2", null, [...(_cache[56] || (_cache[56] = [
                    (0, vue_1.createTextVNode)("CEOs", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.visibleCeoCards, (card, __, ___, _cached) => {
                const _memo = ([card, _ctx.tallCards]);
                if (_cached && _cached.key === card && (0, vue_1.isMemoSame)(_cached, _memo))
                    return _cached;
                const _item = ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                    class: "cardbox",
                    key: card
                }, [
                    (0, vue_1.createVNode)(_component_Card, {
                        card: { 'name': card },
                        autoTall: _ctx.tallCards
                    }, null, 8, ["card", "autoTall"])
                ]));
                _item.memo = _memo;
                return _item;
            }, _cache, 18), 128)),
            _cache[57] || (_cache[57] = (0, vue_1.createElementVNode)("br", null, null, -1))
        ], 512), [
            [vue_1.vShow, _ctx.visibleCeoCards.length > 0]
        ]),
        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("section", _hoisted_38, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h2", null, [...(_cache[58] || (_cache[58] = [
                    (0, vue_1.createTextVNode)("Standard Projects", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.visibleStandardProjectCards, (card, __, ___, _cached) => {
                const _memo = ([card, _ctx.tallCards]);
                if (_cached && _cached.key === card && (0, vue_1.isMemoSame)(_cached, _memo))
                    return _cached;
                const _item = ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                    class: "cardbox",
                    key: card
                }, [
                    (0, vue_1.createVNode)(_component_Card, {
                        card: { 'name': card },
                        autoTall: _ctx.tallCards
                    }, null, 8, ["card", "autoTall"])
                ]));
                _item.memo = _memo;
                return _item;
            }, _cache, 20), 128))
        ], 512), [
            [vue_1.vShow, _ctx.visibleStandardProjectCards.length > 0]
        ]),
        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("section", _hoisted_39, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h2", null, [...(_cache[59] || (_cache[59] = [
                    (0, vue_1.createTextVNode)("Global Events", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.visibleGlobalEvents, (globalEventName, __, ___, _cached) => {
                const _memo = ([globalEventName]);
                if (_cached && _cached.key === globalEventName && (0, vue_1.isMemoSame)(_cached, _memo))
                    return _cached;
                const _item = ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                    class: "cardbox",
                    key: globalEventName
                }, [
                    (0, vue_1.createVNode)(_component_global_event, {
                        globalEventName: globalEventName,
                        type: "distant"
                    }, null, 8, ["globalEventName"])
                ]));
                _item.memo = _memo;
                return _item;
            }, _cache, 22), 128))
        ], 512), [
            [vue_1.vShow, _ctx.visibleGlobalEvents.length > 0]
        ]),
        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("section", null, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h2", null, [...(_cache[60] || (_cache[60] = [
                    (0, vue_1.createTextVNode)("Colonies", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_40, [
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.visibleColonyNames, (colonyName, __, ___, _cached) => {
                    const _memo = ([colonyName, _ctx.showMetadata]);
                    if (_cached && _cached.key === colonyName && (0, vue_1.isMemoSame)(_cached, _memo))
                        return _cached;
                    const _item = ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                        class: "player_home_colony",
                        key: colonyName
                    }, [
                        (0, vue_1.createVNode)(_component_colony, {
                            colony: _ctx.colonyModel(colonyName)
                        }, null, 8, ["colony"])
                    ]));
                    _item.memo = _memo;
                    return _item;
                }, _cache, 24), 128))
            ])
        ], 512), [
            [vue_1.vShow, _ctx.visibleColonyNames.length > 0]
        ]),
        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("section", null, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h2", null, [...(_cache[61] || (_cache[61] = [
                    (0, vue_1.createTextVNode)("Milestones", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_41, [
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.visibleMilestoneNames, (milestoneName, __, ___, _cached) => {
                    const _memo = ([milestoneName]);
                    if (_cached && _cached.key === milestoneName && (0, vue_1.isMemoSame)(_cached, _memo))
                        return _cached;
                    const _item = ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                        class: "player_home_colony",
                        key: milestoneName
                    }, [
                        (0, vue_1.createElementVNode)("div", _hoisted_42, [
                            (0, vue_1.createVNode)(_component_milestone, {
                                milestone: _ctx.milestoneModel(milestoneName),
                                showDescription: true
                            }, null, 8, ["milestone"])
                        ])
                    ]));
                    _item.memo = _memo;
                    return _item;
                }, _cache, 26), 128))
            ])
        ], 512), [
            [vue_1.vShow, _ctx.visibleMilestoneNames.length > 0]
        ]),
        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("section", null, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h2", null, [...(_cache[62] || (_cache[62] = [
                    (0, vue_1.createTextVNode)("Awards", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_43, [
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.visibleAwardNames, (awardName, __, ___, _cached) => {
                    const _memo = ([awardName]);
                    if (_cached && _cached.key === awardName && (0, vue_1.isMemoSame)(_cached, _memo))
                        return _cached;
                    const _item = ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                        class: "player_home_colony",
                        key: awardName
                    }, [
                        (0, vue_1.createElementVNode)("div", _hoisted_44, [
                            (0, vue_1.createVNode)(_component_award, {
                                award: _ctx.awardModel(awardName),
                                showDescription: true
                            }, null, 8, ["award"])
                        ])
                    ]));
                    _item.memo = _memo;
                    return _item;
                }, _cache, 28), 128))
            ])
        ], 512), [
            [vue_1.vShow, _ctx.visibleAwardNames.length > 0]
        ]),
        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("section", null, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h2", null, [...(_cache[63] || (_cache[63] = [
                    (0, vue_1.createTextVNode)("Agendas", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_45, [
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.visibleAgendaIds, (id, __, ___, _cached) => {
                    const _memo = ([id]);
                    if (_cached && _cached.key === id && (0, vue_1.isMemoSame)(_cached, _memo))
                        return _cached;
                    const _item = ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                        class: "player_home_colony",
                        key: id
                    }, [
                        (0, vue_1.createElementVNode)("div", _hoisted_46, [
                            (0, vue_1.createElementVNode)("div", _hoisted_47, [
                                (0, vue_1.createVNode)(_component_turmoil_agenda, { id: id }, null, 8, ["id"]),
                                (0, vue_1.createElementVNode)("div", _hoisted_48, (0, vue_1.toDisplayString)(id), 1)
                            ])
                        ])
                    ]));
                    _item.memo = _memo;
                    return _item;
                }, _cache, 30), 128))
            ])
        ], 512), [
            [vue_1.vShow, _ctx.visibleAgendaIds.length > 0]
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_49, [
            (0, vue_1.createVNode)(_component_preferences_icon)
        ])
    ], 2));
}
